import React from 'react';
import { FileText, History, Receipt, ExternalLink, Edit } from 'lucide-react';

const PaymentHistoryTable = ({ versements = [], onShowReceipt, onEditVersement, receiptLoading = false }) => {
  // Formater la date pour un affichage plus convivial
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Trier les versements par date (plus récent en premier)
  const sortedVersements = [...(versements || [])].sort((a, b) => 
    new Date(b.date_versement) - new Date(a.date_versement)
  );

  if (!sortedVersements || sortedVersements.length === 0) {
    return (
      <div className="bg-white h-full">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <History className="h-5 w-5 text-[#202654]" />
            <h2 className="text-lg font-semibold text-gray-900">Historique des versements</h2>
          </div>
        </div>
        <div className="p-6 h-full flex items-center justify-center">
          <div className="text-center text-gray-500 py-8">
            <Receipt className="h-12 w-12 mx-auto text-gray-300 mb-3" />
            <p>Aucun versement enregistré</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white h-full">
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center space-x-2">
          <History className="h-5 w-5 text-[#202654]" />
          <h2 className="text-lg font-semibold text-gray-900">Historique des versements</h2>
        </div>
      </div>
      <div className="p-6 overflow-y-auto max-h-[calc(100vh-220px)]">
        <div className="space-y-4">
          {sortedVersements.map((versement, index) => (
            <div key={versement.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
              <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
                <div className="flex items-center">
                  <Receipt className="h-4 w-4 text-[#202654] mr-2" />
                  <span className="text-sm font-medium text-gray-900">
                    {formatDate(versement.date_versement)}
                  </span>
                </div>
                <div>
                  <span className="text-base font-semibold text-[#202654]">
                    {(versement.montant || 0).toLocaleString()} FCFA
                  </span>
                </div>
              </div>
              
              <div className="px-4 py-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Mode de paiement</p>
                    <p className="text-sm text-gray-900">{versement.mode_paiement?.libelle || 'Non spécifié'}</p>
                  </div>
                  
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Détails</p>
                    <div className="space-y-1">
                      {versement.lignes_versement?.map((ligne, idx) => (
                        <div key={idx} className="text-sm text-gray-900 flex justify-between">
                          <span>{ligne.libelle}</span>
                          <span className="font-medium">{(ligne.montant || 0).toLocaleString()} FCFA</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                {versement.commentaire && (
                  <div className="mt-3 pt-3 border-t border-gray-100">
                    <p className="text-xs text-gray-500 mb-1">Commentaire</p>
                    <p className="text-sm text-gray-600">{versement.commentaire}</p>
                  </div>
                )}
              </div>
              
              <div className="bg-gray-50 px-4 py-2 border-t border-gray-200 flex justify-end space-x-2">
                {index === 0 && (
                  <button
                    onClick={() => onEditVersement(versement)}
                    className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
                  >
                    <Edit className="h-4 w-4 mr-1.5 text-gray-500" />
                    Modifier
                  </button>
                )}
                <button
                  onClick={() => onShowReceipt(versement.id)}
                  disabled={receiptLoading}
                  className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-[#202654] hover:bg-[#202654]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654] transition-colors"
                >
                  <FileText className="h-4 w-4 mr-1.5" />
                  Voir le reçu
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentHistoryTable;
